export const MIN_SIGNUP_AGE = 14;
export const underAgeMessage = `만 ${MIN_SIGNUP_AGE}세 이상만 가입할 수 있습니다.`;

// 가입 가능한 가장 늦은 생년월일(오늘 기준 만 14세가 되는 날)을 YYYY-MM-DD로 만든다.
export function latestSignupBirthDate(today = new Date()) {
    return `${today.getFullYear() - MIN_SIGNUP_AGE}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
}

// 생년월일(YYYY-MM-DD)이 만 14세 이상인지 확인한다.
export function isSignupAge(birthDate, today = new Date()) {
    return /^\d{4}-\d{2}-\d{2}$/.test(birthDate || '') && birthDate <= latestSignupBirthDate(today);
}
